export default __webpack_public_path__ + "static/media/user.38441a51.svg";